import React, { useEffect } from 'react';

import { PageLayout } from '@/components/templates/PageLayout';
import { CmLongLoading, CmScrollBox } from '@/components/uiParts';
import { MenuManagementBusinessHoursForm } from '@/pages/menu-managements/business-hours/components/MenuManagementBusinessHoursForm';
import { useMenuManagementBusinessHourForm } from '@/pages/menu-managements/business-hours/hooks/useMenuManagementBusinessHourForm';
import { MenuManagementNewButtonArea } from '@/pages/menu-managements/components/TopButtonArea';
import { routes } from '@/router';

const MenuManagementBusinessHoursNewPage: React.FC = (): JSX.Element => {
  const {
    associateBrandSelectInput,
    titleJa,
    memo,
    error,
    targetsHeight,
    dayOfWeekPeriods,
    isLoading,
    handleCreate,
    handleInputTitleJa,
    handleInputMemo,
    handleAddMenuHour,
    handleDeleteTime,
    handleChangeStartTimeHour,
    handleChangeStartTimeMinutes,
    handleChangeEndTimeHour,
    handleChangeEndTimeMinutes,
    initializeNewPageState,
  } = useMenuManagementBusinessHourForm();

  const isRequiredErrorDayOfWeekPeriod = dayOfWeekPeriods.every((dowp) => {
    return dowp.periods.length === 0;
  });

  const isDisabledSubmitButton = [
    !error.titleJa.isTouched || error.titleJa.isError,
    error.memo.isError,
    isRequiredErrorDayOfWeekPeriod,
  ].some((error) => error);

  useEffect(() => {
    (async () => {
      await initializeNewPageState();
    })();
  }, []);

  return (
    <PageLayout
      title={routes.menuManagementBusinessHoursNewPage.title}
      {...{ associateBrandSelectInput }}
    >
      <MenuManagementNewButtonArea
        listUrl="/menu-managements/business-hours"
        {...{ handleCreate, isDisabledSubmitButton }}
      />
      <CmScrollBox height={`calc(100vh - ${targetsHeight}px)`}>
        <MenuManagementBusinessHoursForm
          {...{
            titleJa,
            memo,
            error,
            dayOfWeekPeriods,
            handleAddMenuHour,
            handleDeleteTime,
            handleChangeStartTimeHour,
            handleChangeStartTimeMinutes,
            handleChangeEndTimeHour,
            handleChangeEndTimeMinutes,
            handleInputTitleJa,
            handleInputMemo,
          }}
        />
      </CmScrollBox>
      {isLoading && <CmLongLoading />}
    </PageLayout>
  );
};

export default MenuManagementBusinessHoursNewPage;
